import React, { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { get } from "lodash";
import { NotificationManager } from "react-notifications";

import { FormField } from "../../../../sharedComponents/formField";
import { isInt, isDec } from "../../../../constants/formValidators";
import { secondsToTime } from "../../../../utils/common";
import { reduxForm, Field } from "redux-form";
import { required } from "../../../../constants/formValidators";
import {
	getNutrionJournalEntries,
	addNutritionJournal,
	editNutritionJournal,
	getIngredientWeightsList
} from "../../../../store/actions";
import TimePick from "../../../../sharedComponents/timePicker";

const JournalForm = ({
	setSelectedRecipe,
	selectedRecipe,
	selectedIngredient,
	handleSubmit,
	addNutritionJournal,
	editNutritionJournal,
	getNutrionJournalEntries,
	setToggleAddToJornal,
	setToggleEditJournal,
	setSelectedIngredient,
	setIsFoodItem,
	setIsRecipe,
	initialValues,
	editTime,
	onUpdate,
	initialRecipe,
	date,
	getIngredientWeightsList,
	ingredientWeights
}) => {
	const queryString = `start_date=${moment(date ? date : new Date()).format("YYYY-MM-DD")}&end_date=${moment(
		date ? date : new Date()
	).format("YYYY-MM-DD")}`;
	const [time, setTime] = useState(editTime ? editTime : "00:00:00");

	const courseOptions = [
		{ name: "Breakfast", id: "A" },
		{ name: "Snack 1", id: "B" },
		{ name: "Lunch", id: "C" },
		{ name: "Snack 2", id: "D" },
		{ name: "Dinner", id: "E" },
		{ name: "Other", id: "Z" }
	];
	selectedIngredient && selectedIngredient.id && getIngredientWeightsList(selectedIngredient.id);
	const addToJournal = ({ hunger_after, hunger_before, meal, quantity, measure }) => {
		const recipeOrFood =
			selectedRecipe && selectedRecipe.id
				? { recipe: selectedRecipe.id, entry: selectedRecipe.name  }
				: selectedIngredient && selectedIngredient.id
					? { food: selectedIngredient.id, entry: selectedIngredient.name }
					: initialValues.recipe
						? { recipe: initialValues.recipe }
						: initialValues.food
							? { food: initialValues.food }
							: {};
		const journalTime = isNaN(time) ? time : secondsToTime(time);

		const journalValues = {
			...recipeOrFood,
			added_on: moment(date ? date : new Date()).format("YYYY-MM-DD") + " " + journalTime,
			hunger_after,
			hunger_before,
			meal,
			quantity,
			measure
		};

		const successHandler = () => {
			getNutrionJournalEntries(queryString);

			onUpdate && onUpdate();
			if (!(initialValues && initialValues.id)) {
				setSelectedRecipe(null);
				setSelectedIngredient(null);
				setIsFoodItem(false);
				setIsRecipe(false);
			}
			NotificationManager.success("Journal added!", "", 5000);
		};

		if (initialValues && initialValues.id) {
			setToggleEditJournal(false);
			editNutritionJournal({ id: initialValues.id, ...journalValues }, successHandler);
		} else {
			setToggleAddToJornal(false);
			addNutritionJournal(journalValues, successHandler);
		}
	};

	const resetSelection = () => {
		setSelectedRecipe(null);
		setSelectedIngredient(null);
	};

	return (
		<>
			{(selectedRecipe || selectedIngredient) && !initialRecipe ? (
				<button className="btn" style={{padding: "0", paddingBottom: "50px", textAlign: "left"}} onClick={resetSelection}>
					<span className="text-primary-dark">
						<i className="icon icon-angle-left"></i>
						{selectedRecipe && "Select another recipe"}
						{selectedIngredient && "Select another food item"}
					</span>
				</button>
			) : null}
			<form onSubmit={handleSubmit(addToJournal)} className="d-flex flex-column h-100 flex-fill">
				<div className="flex-fill">
					<div className="row">

						<div className="col-12 mb-3">
							<span> Time </span>
							<TimePick value={time} onChange={setTime} units={['hh', 'mm']} />
						</div>

						<Field
							label="Course"
							name="meal"
							type="select"
							formGroupClass="col-12"
							options={courseOptions}
							component={FormField}
							defaultVal={"Z"}
						/>
						{selectedRecipe ? (
							<div className="form-group col-12 false">
								<label>Serving Size</label>
								<p className="m-0" style={{ fontWeight: "bolder" }}>{selectedRecipe.serving_size}</p>
							</div>
						) : null}
						{selectedIngredient ? (
							<Field
								name="measure"
								label="Weights"
								type="select"
								options={ingredientWeights}
								viewValue={["quantity", "measure"]}
								formGroupClass="col-12"
								component={FormField}
								validate={[required]}
							/>
						) : null}
						<Field
							label="Quantity"
							name="quantity"
							type="number"
							min={0}
							max={999}
							step=".01"
							formGroupClass="col-12"
							component={FormField}
							validate={[isDec, required]}
						/>
						<Field
							label="Hunger Before"
							name="hunger_before"
							type="number"
							formGroupClass="col-12"
							component={FormField}
							min={0}
							max={10}
							validate={[isInt]}
						/>
						<Field
							label="Hunger After"
							name="hunger_after"
							type="number"
							min={0}
							max={10}
							formGroupClass="col-12"
							component={FormField}
							validate={[isInt]}
						/>
					</div>
					<div className="filter-footer sticky-footer text-right px-0">
						<button type="submit" className="btn btn-primary">
							Save To Journal
						</button>
					</div>
				</div>
			</form>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		ingredientWeights: get(state, "AddRecipe.getIngredientWeights.results", [])
	};
};

const mapDispatchToProps = { getNutrionJournalEntries, addNutritionJournal, editNutritionJournal, getIngredientWeightsList };

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(
	reduxForm({
		form: "JournalForm"
	})(JournalForm)
);
